import { isBRServer } from '@/utils/Validators/validation';
import { COUNTRY } from '..';

const SUPPORT_URLS_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br',
  es: 'https://soporte.hostgator.mx/hc/es-419',
};

const SUPPORT_ARTICLES_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/',
};

const SUPPORT_ARTICLE_ZONEMANAGER_CPANEL_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389554',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/216721158',
};

const SUPPORT_ARTICLE_ZONEMANAGER_WHM_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360054179034',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049678232',
};

const SUPPORT_ARTICLE_DNS_THROUGH_WHM_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360056256934',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360052091152',
};

const SUPPORT_ARTICLE_DNS_REGISTROBR_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360056449953',
  es: '',
};

const SUPPORT_ARTICLE_DNS_UOLHOST_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360054626714',
  es: '',
};

const SUPPORT_ARTICLE_DNS_GODADDY_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360056450093',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049858232',
};

const SUPPORT_ARTICLE_DNS_LOCAWEB_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360056450213',
  es: '',
};

const SUPPORT_ARTICLE_DNS_KINGHOST_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360054626834',
  es: '',
};

const SUPPORT_ARTICLE_DNS_WEBEMPRESA_BY_BRAND = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049858332',
};

const SUPPORT_ARTICLE_DNS_COLOMBIAHOSTING_BY_BRAND = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360050315211',
};

const SUPPORT_ARTICLE_DNS_NEUBOX_BY_BRAND = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049858512',
};

const SUPPORT_ARTICLE_KNOW_MORE_DNS_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360019596774',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049678152',
};

const SUPPORT_ARTICLE_KNOW_MORE_DNS_POINTER_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360054298934',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360049748272',
};

const RESELLER_PRICE_UPDATE_EXPLANATION_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/1260800338969',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360053346131',
};

const GET_A_NEW_PLAN_BY_BRAND = {
  br: 'http://hostgator.com.br/email-profissional',
  es: `http://hostgator.${COUNTRY.toLowerCase()}/correo-profesional`,
};

const TITAN_FAQ_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/categories/1260801368689',
  es: 'https://soporte.hostgator.mx/hc/es-419/categories/28437884383123',
};

const CHAT_SUPPORT_URL_BY_BRAND = {
  br: 'https://financeiro.hostgator.com.br/chat/?country=br&department=technical#',
  es: `https://billing.hostgator.${COUNTRY.toLowerCase()}/chat/?country=mx&department=technical#`,
};

const GET_A_NEW_DOMAIN_BY_BRAND = {
  br: 'https://www.hostgator.com.br/registro-de-dominio',
  es: `https://www.hostgator.${COUNTRY.toLowerCase()}/dominios`,
};

const SERVICE_TERMS_BY_BRAND = {
  br: 'https://www.hostgator.com.br/termos-de-servico',
  es: `https://www.hostgator.${COUNTRY.toLowerCase()}/terminos`,
};

const SERVICE_TERMS_REFUND_BY_BRAND = {
  br: `${SERVICE_TERMS_BY_BRAND.br}#Cancelamentos%20e%20reembolso`,
  es: `${SERVICE_TERMS_BY_BRAND.es}#:~:text=14%2E%20Reembolsos`,
};

const GET_ANALYZER_LINK_BY_BRAND = {
  br: 'analise@hostgator.com.br',
  es: 'https://soporte-latam.hostgator.com',
};

const CHANGE_REGISTROBR_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389114',
  es: '',
};

const CHANGE_GODADDY_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360037642314',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360037746791',
};

const CHANGE_LOCAWEB_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360037640614',
  es: '',
};

const CHANGE_UOLHOST_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360037642134',
  es: '',
};

const CHANGE_KINGHOST_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360037644234',
  es: '',
};

const CHANGE_OTHERS_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000497973#registrado-em-outro-provedor',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217236957',
};

const CHANGE_WEBEMPRESA_DNS = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360037758891',
};

const CHANGE_COLOMBIAHOSTING_DNS = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360037389492',
};

const CHANGE_NEUBOX_DNS = {
  br: '',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360037755071',
};

const GODADDY_PAGE = {
  br: 'https://www.godaddy.com/',
  es: 'https://www.godaddy.com/',
};

const REGISTROBR_PAGE = {
  br: 'https://registro.br/',
  es: '',
};

const LOCAWEB_PAGE = {
  br: 'https://www.locaweb.com.br/',
  es: '',
};

const UOLHOST_PAGE = {
  br: 'https://uolhost.uol.com.br/',
  es: '',
};

const KINGHOST_PAGE = {
  br: 'https://king.host/',
  es: '',
};

const WEBEMPRESA_PAGE = {
  br: '',
  es: 'https://www.webempresa.com/',
};

const COLOMBIAHOSTING_PAGE = {
  br: '',
  es: 'https://www.colombiahosting.com.co/',
};

const NEUBOX_PAGE = {
  br: '',
  es: 'https://neubox.com/',
};

const EXTERNAL_PLATFORM_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/7499808508699',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/7527058595995',
};

const PERSONAL_DNS_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389294',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/7511270022939',
};

const DEFAULT_SERVER_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/7498793589147',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/7513054970395',
};

const BACKUP_INFO_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000385173-Como-fazer-um-backup-completo',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/115000322691',
};

const WOOCOMMERCE_ARTICLE_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/6405989020571-O-que-%C3%A9-WooCommerce-',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/7067232595995',
};

const GMAIL_CREATE_ACCOUNT_BY_BRAND = {
  br: 'https://support.google.com/mail/answer/56256?hl=pt-BR',
  es: 'https://support.google.com/mail/answer/56256?hl=es',
};

const FIRST_STEP_ASAAS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091634807323',
  es: '',
};

const ASAAS_INTEGRATION = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091716998171',
  es: '',
};

const HOW_ACCESS_ASAAS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091679825563',
  es: '',
};

const ASAAS_TAX = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091657649947',
  es: '',
};

const ASAAS_HELP_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091680144283-O-que-%C3%A9-Asaas-',
  es: '',
};

const QUESTIONS_ABOUT_ASAAS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/10091660667163',
  es: '',
};

const MORE_CONTENT_ASAAS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/sections/10091537440667',
  es: '',
};

const ASAAS_LOGIN = {
  br: 'https://www.asaas.com/login/',
  es: '',
};

const DNS_PROPAGATION = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000451693-O-que-%C3%A9-propaga%C3%A7%C3%A3o-#propaga%C3%A7%C3%A3o',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360024988331',
};

const FIND_PLAN_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115004894674',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360024790012',
};

const CLIENT_AREA_FEATURES = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/360015388394',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360025090791',
};

const CONFIGURE_DOMAIN_DNS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000497973',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217236957--C%C3%B3mo-cambiar-el-DNS-',
};

const ADD_DOMAIN_TO_HOST = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000389314',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217618308',
};

const CREATE_WORDPRESS_SITE = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115001935813',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217577968-Softaculous-C%C3%B3mo-instalar-WordPress-',
};

const ACCESS_CPANEL = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000181933',
  es: 'https://soporte-latam.hostgator.com/hc/es-419/articles/360021861252--C%C3%B3mo-acceder-al-cPanel-',
};

const BLOG = {
  br: 'https://www.hostgator.com.br/blog/',
  es: 'https://www.hostgator.mx/blog/',
};

const YOUTUBE = {
  br: 'https://www.youtube.com/HostGatorBRTV',
  es: 'https://www.youtube.com/@HostGatorMexico',
};

const HELP_CENTER = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br',
  es: 'https://soporte.hostgator.mx/hc/es-419',
};


const DO_YOUR_ON_BACKUP_BY_BRAND = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/1260804497929',
  es: '',
};

const AUTH_HOSTGATOR = {
  br: `https://auth.hostgator.com.${COUNTRY.toLowerCase()}`,
  es: `https://auth.hostgator.${COUNTRY.toLowerCase()}`,
};

const MAIA_TERMS_OF_USE_BY_BRAND = {
  br: 'https://www.hostgator.com.br/termos-de-servico',
  mx: 'https://www.hostgator.mx/terminos',
  cl: 'https://www.hostgator.cl/terminos',
  co: 'https://www.hostgator.co/terminos',
  ar: 'https://www.hostgator.ar/terminos',
  pe: 'https://www.hostgator.pe/terminos',
  ec: 'https://www.hostgator.net.ec/terminos',
  uy: 'https://www.hostgator.uy/terminos',
  do: 'https://www.hostgator.do/terminos',
  bo: 'https://www.hostgator.bo/terminos',
};

const MAIA_PRIVACY_POLICY_BY_BRAND = {
  br: 'https://www.newfold.com/privacy-center/privacy',
  mx: 'https://www.hostgator.mx/politica-uso-aceptable',
  cl: 'https://www.hostgator.cl/politica-uso-aceptable',
  co: 'https://www.hostgator.co/politica-uso-aceptable',
  ar: 'https://www.hostgator.ar/politica-uso-aceptable',
  pe: 'https://www.hostgator.pe/politica-uso-aceptable',
  ec: 'https://www.hostgator.net.ec/politica-uso-aceptable',
  uy: 'https://www.hostgator.uy/politica-uso-aceptable',
  do: 'https://www.hostgator.do/politica-uso-aceptable',
  bo: 'https://www.hostgator.bo/politica-uso-aceptable',
};

export const AUTH_HOSTGATOR_URL = AUTH_HOSTGATOR[isBRServer ? 'br' : 'es'];

export const DO_YOUR_ON_BACKUP = DO_YOUR_ON_BACKUP_BY_BRAND[isBRServer ? 'br' : 'es'];

export const GMAIL_CREATE_ACCOUNT = GMAIL_CREATE_ACCOUNT_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SUPPORT_URL = SUPPORT_URLS_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLES = SUPPORT_ARTICLES_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_ZONEMANAGER_CPANEL = SUPPORT_ARTICLE_ZONEMANAGER_CPANEL_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_ZONEMANAGER_WHM = SUPPORT_ARTICLE_ZONEMANAGER_WHM_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_THROUGH_WHM = SUPPORT_ARTICLE_DNS_THROUGH_WHM_BY_BRAND[isBRServer ? 'br' : 'es'];
export const CHAT_SUPPORT_URL = CHAT_SUPPORT_URL_BY_BRAND[isBRServer ? 'br' : 'es'];

export const EXTERNAL_PLATFORM = EXTERNAL_PLATFORM_BY_BRAND[isBRServer ? 'br' : 'es'];
export const PERSONAL_DNS = PERSONAL_DNS_BY_BRAND[isBRServer ? 'br' : 'es'];
export const DEFAULT_SERVER = DEFAULT_SERVER_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SUPPORT_ARTICLE_DNS_REGISTROBR = SUPPORT_ARTICLE_DNS_REGISTROBR_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_UOLHOST = SUPPORT_ARTICLE_DNS_UOLHOST_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_GODADDY = SUPPORT_ARTICLE_DNS_GODADDY_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_LOCAWEB = SUPPORT_ARTICLE_DNS_LOCAWEB_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_KINGHOST = SUPPORT_ARTICLE_DNS_KINGHOST_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_WEBEMPRESA = SUPPORT_ARTICLE_DNS_WEBEMPRESA_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_COLOMBIAHOSTING = SUPPORT_ARTICLE_DNS_COLOMBIAHOSTING_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_DNS_NEUBOX = SUPPORT_ARTICLE_DNS_NEUBOX_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SUPPORT_ARTICLE_KNOW_MORE_DNS = SUPPORT_ARTICLE_KNOW_MORE_DNS_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_KNOW_MORE_DNS_POINTER = SUPPORT_ARTICLE_KNOW_MORE_DNS_POINTER_BY_BRAND[isBRServer ? 'br' : 'es'];
export const RESELLER_PRICE_UPDATE_EXPLANATION = RESELLER_PRICE_UPDATE_EXPLANATION_BY_BRAND[isBRServer ? 'br' : 'es'];
export const GET_A_NEW_PLAN = GET_A_NEW_PLAN_BY_BRAND[isBRServer ? 'br' : 'es'];
export const TITAN_FAQ = TITAN_FAQ_BY_BRAND[isBRServer ? 'br' : 'es'];
export const GET_A_NEW_DOMAIN = GET_A_NEW_DOMAIN_BY_BRAND[isBRServer ? 'br' : 'es'];
export const GET_ANALYZER_LINK = GET_ANALYZER_LINK_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SERVICE_TERMS = SERVICE_TERMS_BY_BRAND[isBRServer ? 'br' : 'es'];
export const SERVICE_TERMS_REFUND = SERVICE_TERMS_REFUND_BY_BRAND[isBRServer ? 'br' : 'es'];

export const SUPPORT_ARTICLE_CHANGE_DNS_REGISTROBR = CHANGE_REGISTROBR_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_GODADDY = CHANGE_GODADDY_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_LOCAWEB = CHANGE_LOCAWEB_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_UOLHOST = CHANGE_UOLHOST_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_KINGHOST = CHANGE_KINGHOST_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_OTHERS = CHANGE_OTHERS_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_WEBEMPRESA = CHANGE_WEBEMPRESA_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_COLOMBIAHOSTING = CHANGE_COLOMBIAHOSTING_DNS[isBRServer ? 'br' : 'es'];
export const SUPPORT_ARTICLE_CHANGE_DNS_NEUBOX = CHANGE_NEUBOX_DNS[isBRServer ? 'br' : 'es'];
export const GODADDY_HOMEPAGE = GODADDY_PAGE[isBRServer ? 'br' : 'es'];
export const REGISTROBR_HOMEPAGE = REGISTROBR_PAGE[isBRServer ? 'br' : 'es'];
export const LOCAWEB_HOMEPAGE = LOCAWEB_PAGE[isBRServer ? 'br' : 'es'];
export const UOLHOST_HOMEPAGE = UOLHOST_PAGE[isBRServer ? 'br' : 'es'];
export const KINGHOST_HOMEPAGE = KINGHOST_PAGE[isBRServer ? 'br' : 'es'];
export const WEBEMPRESA_HOMEPAGE = WEBEMPRESA_PAGE[isBRServer ? 'br' : 'es'];
export const COLOMBIAHOSTING_HOMEPAGE = COLOMBIAHOSTING_PAGE[isBRServer ? 'br' : 'es'];
export const NEUBOX_HOMEPAGE = NEUBOX_PAGE[isBRServer ? 'br' : 'es'];

export const BACKUP_INFO = BACKUP_INFO_BY_BRAND[isBRServer ? 'br' : 'es'];
export const WOOCOMMERCE_ARTICLE = WOOCOMMERCE_ARTICLE_BY_BRAND[isBRServer ? 'br' : 'es'];
export const ASAAS_INTEGRATION_ARTICLE = ASAAS_INTEGRATION[isBRServer ? 'br' : 'es'];
export const HOW_ACCESS_ASAAS_ARTICLE = HOW_ACCESS_ASAAS[isBRServer ? 'br' : 'es'];
export const FIRST_STEP_ASAAS_ARTICLE = FIRST_STEP_ASAAS[isBRServer ? 'br' : 'es'];
export const ASAAS_TAX_ARTICLE = ASAAS_TAX[isBRServer ? 'br' : 'es'];
export const QUESTIONS_ABOUT_ASAAS_ARTICLE = QUESTIONS_ABOUT_ASAAS[isBRServer ? 'br' : 'es'];
export const MORE_CONTENT_ASAAS_ARTICLE = MORE_CONTENT_ASAAS[isBRServer ? 'br' : 'es'];
export const ASAAS_LOGIN_LINK = ASAAS_LOGIN[isBRServer ? 'br' : 'es'];
export const ASAAS_HELP = ASAAS_HELP_BY_BRAND[isBRServer ? 'br' : 'es'];

export const DNS_PROPAGATION_ARTICLE = DNS_PROPAGATION[isBRServer ? 'br' : 'es'];
export const FIND_PLAN_DNS_ARTICLE = FIND_PLAN_DNS[isBRServer ? 'br' : 'es'];
export const CLIENT_AREA_FEATURES_ARTICLE = CLIENT_AREA_FEATURES[isBRServer ? 'br' : 'es'];
export const CONFIGURE_DOMAIN_DNS_ARTICLE = CONFIGURE_DOMAIN_DNS[isBRServer ? 'br' : 'es'];
export const ADD_DOMAIN_TO_HOST_ARTICLE = ADD_DOMAIN_TO_HOST[isBRServer ? 'br' : 'es'];
export const CREATE_WORDPRESS_SITE_ARTICLE = CREATE_WORDPRESS_SITE[isBRServer ? 'br' : 'es'];
export const ACCESS_CPANEL_ARTICLE = ACCESS_CPANEL[isBRServer ? 'br' : 'es'];

export const BLOG_URL = BLOG[isBRServer ? 'br' : 'es'];
export const YOUTUBE_URL = YOUTUBE[isBRServer ? 'br' : 'es'];
export const HELP_CENTER_URL = HELP_CENTER[isBRServer ? 'br' : 'es'];

export const MAIA_TERMS_OF_USE = MAIA_TERMS_OF_USE_BY_BRAND[COUNTRY];
export const MAIA_PRIVACY_POLICY = MAIA_PRIVACY_POLICY_BY_BRAND[COUNTRY];
